import React, { useState } from "react";
import { Form, Button, Card, Alert, Spinner, Container, Row, Col } from "react-bootstrap";
import axios from "../context/AxiosInstance";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./PersonnelLoginPage.css";

const PersonnelLoginPage = () => {
  const [formData, setFormData] = useState({
    login: "",
    mot_de_passe: ""
  });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.login || !formData.mot_de_passe) {
      setError("Veuillez remplir tous les champs");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await axios.post("/personnel/login-personnel/", {
        login: formData.login,
        mot_de_passe: formData.mot_de_passe
      });

      if (response.data.access_token) {
        // Adapter au contrat du context: login(token, role, userData)
        const token = response.data.access_token;
        const userData = response.data.user;
        const role = (userData?.type_compte || "PERSONNEL").toUpperCase();
        const ok = login(token, role, userData);
        navigate("/personnel/dashboard");
      }
    } catch (err) {
      console.error("Erreur de connexion:", err);
      if (err.response?.data?.detail) {
        setError(err.response.data.detail);
      } else {
        setError("Erreur de connexion. Vérifiez vos identifiants.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="personnel-login-page">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col md={6} lg={4}>
            <Card className="shadow-lg border-0">
              <Card.Body className="p-5">
                <div className="text-center mb-4">
                  <img 
                    src="/aguipex_logo.png" 
                    alt="Logo Aguipex" 
                    height="80"
                    className="mb-3"
                  />
                  <h2 className="fw-bold text-primary mb-2">Espace Personnel</h2>
                  <p className="text-muted">Connectez-vous à votre espace personnel</p>
                </div>

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">
                      👤 Login
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="login"
                      value={formData.login}
                      onChange={handleChange}
                      placeholder="Entrez votre login"
                      className="form-control-lg"
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label className="fw-semibold">
                      🔐 Mot de passe
                    </Form.Label>
                    <Form.Control
                      type="password"
                      name="mot_de_passe"
                      value={formData.mot_de_passe}
                      onChange={handleChange}
                      placeholder="Entrez votre mot de passe"
                      className="form-control-lg"
                      required
                    />
                  </Form.Group>

                  {error && (
                    <Alert variant="danger" className="mb-3">
                      <div className="text-center">
                        <strong>❌ Erreur</strong>
                        <br />
                        <span>{error}</span>
                      </div>
                    </Alert>
                  )}

                  <div className="d-grid">
                    <Button
                      type="submit"
                      variant="primary"
                      size="lg"
                      disabled={loading}
                      className="fw-bold"
                    >
                      {loading ? (
                        <>
                          <Spinner animation="border" size="sm" className="me-2" />
                          Connexion...
                        </>
                      ) : (
                        "🚀 Se connecter"
                      )}
                    </Button>
                  </div>
                </Form>

                <div className="text-center mt-4">
                  <small className="text-muted">
                    Mot de passe oublié ? Contactez votre administrateur.
                  </small>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PersonnelLoginPage;
